import PropTypes from "prop-types";
import { MenuIcon } from "lucide-react";

import { Button } from "@/components/ui/button";

// Floating hamburger pinned top-left on mobile/tablet. Hidden on `lg`
// and up since the persistent sidebar is always visible.

MobileMenuButton.propTypes = {
  onOpenSidebar: PropTypes.func,
};

export default function MobileMenuButton({ onOpenSidebar }) {
  return (
    <Button
      variant="outline"
      size="icon"
      onClick={onOpenSidebar}
      aria-label="Open navigation"
      className="fixed left-4 top-4 z-50 size-10 bg-background shadow-md lg:hidden"
    >
      <MenuIcon className="size-5" />
    </Button>
  );
}
